import React, { useState } from "react";
import { FaImage } from "react-icons/fa";

import { useDispatch } from "react-redux";
import { closeModal } from "../../redux/features/modalSlice";
import { useCreateSubCategoryMutation,} from "../../redux/services/subCategoriesService/subCategories.Services";
import {useGetCategoriesQuery} from "../../redux/services/categoriesService/categories.Services";
import { useNavigate } from "react-router";
import { successToast } from "../../Utils/toast";
function AddSubCategory() {
    const navigate= useNavigate();
  const dispatch = useDispatch();
  const [preview, setPreview] = useState(null);
  const [image, setImage] = useState(null);
  const [formData, setFormData] = useState({
    name: "",
    description: "",
    category_id: "",
    image:null
  });
 const [createSubCategory, { isLoading }] =useCreateSubCategoryMutation();
  const { data: categoryData } = useGetCategoriesQuery();
  const categories = categoryData?.data || [];
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };
const handleImageChange = (e) => {
  const file = e.target.files[0];
  if (file) {
    setImage(file); 
    setPreview(URL.createObjectURL(file)); 
  }
};
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
    const payload = new FormData();
    payload.append("name", formData.name);
    payload.append("description", formData.description);
    payload.append("category_id", formData.category_id);
    if (image) {
      payload.append("image", image);
    }

  const res = await createSubCategory(payload).unwrap();
  if (res.success === 1) {
    successToast(res.message)
    dispatch(closeModal());
    navigate("/sub-categories-list");
  }
      
    } catch (error) {
      console.log(error);
      alert("Something went wrong");
    }
  };
  return (
    <div>
 <div className="page-header-breadcrumb all_breadcrumb">
                <div className="ms-md-1 mb-1 mb-md-0 ms-0 page_heading_breadcrumb">
                    <nav>
                        <h4 className="fw-semibold">
                            Add SubCategories
                        </h4>
                        <ol className="breadcrumb mb-0">
                            <li className="breadcrumb-item">
                                <navigate to="/">
                                    Home
                                </navigate>
                            </li>

                            <li
                                className="breadcrumb-item active"
                                aria-current="page"
                            >
                                Add SubCategories
                            </li>

                        </ol>

                    </nav>

                </div>
                <div className="page-title fw-semibold fs-18 mb-0">

                    <button
                        className="btn btn-primary me-2"
                        onClick={() => navigate(-1)}
                    >

                        <span>
                            <i className="fe fe-shopping-cart me-1"></i>
                        </span>

                        SubCategories List

                    </button>

                </div>

            </div>
        <div className="card border-0 shadow-sm rounded-4">
        <div className="card-body p-4">
          <form onSubmit={handleSubmit}>
            <div className="row g-4">
              <div className="col-md-6">
                <div className="amenities-form-group">
                  <label className="form-label fw-semibold">
                    SubCategory Name
                  </label>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    className="form-control custumform"
                    placeholder="Enter SubCategory Name"
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="amenities-form-group">
                  <label className="form-label fw-semibold">
                    Select Category
                  </label>
                  <select
                    name="category_id"
                    value={formData.category_id}
                    onChange={handleChange}
                    className="form-control custumform"
                  >
                    <option value="">
                      Select Category
                    </option>
                    {categories.map((item) => (
                      <option
                        key={item.id}
                        value={item.id}
                      >
                        {item.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="col-md-12">
                <div className="amenities-form-group">
                  <label className="form-label fw-semibold">
                    Description
                  </label>
                  <textarea
                    rows="4"
                    name="description"
                    value={formData.description}
                    onChange={handleChange}
                    className="form-control custumform"
                    placeholder="Enter Description"
                  />

                </div>

              </div>

              {/* IMAGE */}
              <div className="col-md-6">

                <div className="amenities-form-group">

                  <label className="form-label fw-semibold">
                    Upload Image
                  </label>

                  <input
                    type="file"
                    className="form-control custumform"
                    accept="image/*"
                    onChange={handleImageChange}
                  />

                  {/* PREVIEW */}
                  <div className="mt-3">

                    {preview ? (

                      <div className="image-preview-box">

                        <img
                          src={preview}
                          alt="Preview"
                          className="preview-image"
                        />

                      </div>

                    ) : (

                      <div className="upload-placeholder">

                        <FaImage size={40} />

                        <p className="mb-0 mt-2">
                          Image Preview
                        </p>

                      </div>

                    )}

                  </div>

                </div>

              </div>

              {/* BUTTON */}
              <div className="col-12">

                <div className="d-flex justify-content-end">

                  <div className="button_submit">

                    <button
                      type="submit"
                      disabled={isLoading}
                    >

                      {
                        isLoading
                          ? "Creating..."
                          : "Create SubCategory"
                      }

                    </button>

                  </div>

                </div>

              </div>

            </div>

          </form>

        </div>

      </div>

    </div>
  );
}

export default AddSubCategory;